import { APIProvider } from '@vis.gl/react-google-maps';
import { type PropsWithChildren } from 'react';

const MapProvider = ({ children }: PropsWithChildren) => (
  <APIProvider apiKey={import.meta.env.VITE_MAPS_API_KEY}>{children}</APIProvider>
);

export default MapProvider;
